module.exports = __webpack_public_path__ + "img/glogo225.1137cd61.png";